import makeStyles from '@mui/styles/makeStyles';

import { getThemeColor } from '../../utils/colors';

export const useStyles = makeStyles((theme) => ({
  card: {
    border: '1px solid transparent',
    borderRadius: '1rem',
    backgroundColor: ({ bgColor = 'focus00' }) => getThemeColor(theme, bgColor),
    color: ({ bgColor = 'focus00', textColor }) => {
      // Set text color to be the contrast of the background color if text color is not set.
      const contrastColor = textColor ? null : bgColor;
      return getThemeColor(theme, textColor, contrastColor);
    },
    display: 'block',
    padding: 0,
    transitionProperty: 'color, background-color, border-color, box-shadow',
    transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)', // ease-out
    transitionDuration: '150ms',
    textAlign: 'left',
    textDecoration: 'none',
    width: 'fill-available',
    ...theme.typography.body_smallRegular,

    // Add sensible resets
    '& figure': {
      margin: 0
    },

    '& img, & svg, & picture': {
      display: 'block',
      maxWidth: '100%'
    },

    // Set custom focus state and override default MUI focus for links and buttons.
    '&:focus': {
      outline: '0 !important',
      boxShadow: '0 0 0 8px #0339F8' // wisdom40
    },

    // Set hover state for Cards that are links or buttons.
    '&[href]:hover, &[type="button"]:hover': {
      backgroundColor: theme.palette.peace10.main,
      cursor: 'pointer',
      textDecoration: 'none'
    },

    // MUI is old and not upto date with better gap methods.
    '& .MuiGrid-container': {
      flexGrow: 1,
      columnGap: 'clamp(1.25rem, 3vw, 2rem)',
      width: 'auto'
    },

    // Remove bottom margin from the last child inside a <Grid item />
    '& .MuiGrid-item > :last-child': {
      marginBottom: '0'
    }
  },

  // Card: Variant
  'card--outlined': {
    borderColor: theme.palette.focus90.main,
    boxShadow: ({ shadowSize }) => `${shadowSize} ${shadowSize} 0px ${theme.palette.focus90.main}`
  },

  card__body: {
    // Override MUI default padding and :last-child
    '&, &:last-child': {
      padding: 'clamp(1rem, 3vw, 1.25rem) clamp(1.25rem, 3vw, 2rem)'
    },

    '&:first-child, & :first-child': {
      marginTop: 0
    },

    '& :last-child': {
      marginBottom: 0
    }
  },

  card__image: {
    display: 'flex',
    justifyContent: 'center'
  },

  card__label: {
    '&.MuiChip-root': {
      backgroundColor: theme.palette.focus90.main,
      borderRadius: '1rem',
      color: theme.palette.focus00.main,
      cursor: 'inherit',
      display: 'inline-flex',
      alignItems: 'center',
      columnGap: '0.5rem',
      fontSize: '0.75rem',
      lineHeight: '0.9375rem',
      height: 'auto', // mui override
      margin: 0,
      padding: '0.25rem 0.75rem'
    },

    '& > svg:first-child': {
      marginLeft: '-0.25rem'
    },
    '& > .MuiChip-icon': {
      color: 'inherit',
      margin: '0 0 0 -0.25rem'
    },
    '& .MuiChip-label': {
      padding: 0
    }
  },

  card__text: {
    margin: '0 0 1rem',
    overflowWrap: 'break-word'
  },

  card__title: {
    ...theme.typography.body_largeBold,
    margin: '0 0 0.25rem',
    overflowWrap: 'break-word'
  }
}));
